const s = (i, n, r) => {
  const o = /^(-|null|-null|null-|undefined|-undefined|undefined-|-)$/gi, t = (e) => {
    if (e) {
      const u = e.match(o);
      let l = e;
      return u && u.forEach((f) => {
        l = l.replace(f, "");
      }), l || null;
    }
    return null;
  };
  return n ? [n].filter((e) => e ?? null).join("-").replace(/\s/g, "-").trim().toLowerCase() : [t(r?.prefix), n ?? i, t(r?.suffix)].filter((e) => e ?? null).join("-").replace(/\s/g, "-").trim().toLowerCase();
};
export {
  s
};
//# sourceMappingURL=useDataId.ByzSN1OB.js.map
